import AudienceCompatibilityValidation from '@/descriptors/AudienceCompatibilityValidation';
import Audience from '@/entities/Audience';
import api from '@/services/Api';

export default {
  getList({ id, type }) {
    const data = {
      ad_account_id: id,
    };
    if (type) {
      data['type'] = type;
    }

    const query = new URLSearchParams(data).toString();

    return api()
      .get('/audiences?' + query)
      .then(resp => resp.map(i => new Audience(i)));
  },

  refresh(id) {
    const data = { ad_account_id: id };

    return api()
      .post('/audiences/refresh', data)
      .then(resp => resp.map(i => new Audience(i)));
  },

  validateAudienceCompatibility(
    adAccountId,
    minAge,
    isAdvantagePlus,
    audiences,
    geoLocations,
    specialAdCategories,
    specialAdCategoryCountries,
  ) {
    const data = {
      ad_account_id: adAccountId,
      min_age: minAge,
      is_advantage_plus: isAdvantagePlus,
      audiences,
      geo_locations: geoLocations,
      special_ad_categories: specialAdCategories,
      special_ad_category_country: specialAdCategoryCountries,
    };

    return api()
      .post('/audiences/validate-compatibility', data )
      .then(resp => new AudienceCompatibilityValidation(resp));
  },
};
